import { Divider, Flex, Typography } from "antd"
import { useLocation, useNavigate } from "react-router-dom"

import Icon from "../../../Icon"
import { buildSearchWithFlag } from "../../../Utils/queryFlags"
import { ensureHttps } from "../../../Utils/utils"

import "./TitleSection.less"

const { Title, Text } = Typography

const TitleSection = ({ title, link, queryParam, queryButtonText = "View logs" }) => {
  const navigate = useNavigate()
  const { pathname, search } = useLocation()

  const handleOpenQueryModal = () => {
    navigate({
      pathname,
      search: buildSearchWithFlag(search, queryParam, true)
    })
  }

  return (
    <div className="business-settings-title-section">
      <Flex align="center" justify="space-between" gap={16} wrap>
        <div>
          <Title level={4}>{title}</Title>
          <a href={ensureHttps(link)} target="_blank" rel="noopener noreferrer">
            {link}
          </a>
        </div>
        {queryParam && (
          <button
            className="title-section-logs-trigger"
            onClick={handleOpenQueryModal}
            type="button"
          >
            <Icon type="info_bubble_empty" className="descriptor-logs-trigger-icon" />
            <Text type="secondary" strong>
              {queryButtonText}
            </Text>
          </button>
        )}
      </Flex>
      <Divider />
    </div>
  )
}

export default TitleSection
